<template>
  <datepicker
    input-class="datepicker__input"
    calendar-class="datepicker__calendar"
    :placeholder="placeholder"
    :disabled-dates="{to: limitTo,from: limitFrom}"
    @input="(value) => $emit('input', value)"
  ></datepicker>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import moment from "moment";

export default {
  name: "RumieDatepicker",
  props: {
    placeholder: String,
    limitToDate: Boolean,
    limitYears: Number
  },
  data() {
    return {};
  },
  computed: {
    limitTo() {
      if (this.limitYears) {
        return moment().subtract(this.limitYears, "y")._d;
      }
      return null;
    },
    limitFrom() {
      return this.limitToDate ? moment()._d : null;
    }
  },
  components: {
    Datepicker
  }
};
</script>

<style>
.datepicker__input {
  border: none;
  box-sizing: border-box;
  background: var(--grey-lighter);
  border-radius: var(--border-radius-md);
  padding: var(--spacing-3) var(--spacing-3);
  width: 100%;
  font-size: var(--base);
  line-height: var(--leading-normal);
}

.datepicker__calendar {
  color: var(--black);
}
</style>
